import { Link } from "react-router-dom";
import { categoryNameMap, formatViews, type Video } from "@/mocks/videos";
import FavoriteButton from "@/components/base/FavoriteButton";

interface VideoCardProps {
  video: Video;
  index?: number;
}

export default function VideoCard({ video, index = 0 }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      data-product-shop="video"
      style={{ animationDelay: `${Math.min(index, 10) * 40}ms` }}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors animate-fade-up cursor-pointer"
    >
      <div className="relative w-full aspect-video overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={`${video.title} - 亲吻视频封面`}
          title={`${video.title} - 亲嘴视频`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 via-transparent to-transparent" />
        <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-foreground-950/75 text-background-50 text-xs font-label">
          {video.duration}
        </span>
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded bg-secondary-100/90 text-secondary-900 text-xs font-label">
          {categoryNameMap[video.categoryKey]}
        </span>
        <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
          <FavoriteButton videoId={video.id} size="sm" />
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-2xl" />
          </div>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-medium text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
          {video.title}
        </h3>
        <div className="mt-2 flex items-center gap-3 text-xs text-foreground-500 font-label flex-wrap">
          <span className="flex items-center gap-1">
            <i className="ri-play-circle-line" />
            {formatViews(video.views)} 次播放
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line" />
            {video.uploadedAt}
          </span>
        </div>
      </div>
    </Link>
  );
}